import { useEffect } from 'react';

type SavedBodyStyles = {
  position: string;
  top: string;
  left: string;
  right: string;
  width: string;
  overflowY: string;
};

let lockCount = 0;
let savedScrollY = 0;
let savedStyles: SavedBodyStyles | null = null;

function applyLock() {
  const body = document.body;
  savedScrollY = window.scrollY || window.pageYOffset || 0;
  savedStyles = {
    position: body.style.position || '',
    top: body.style.top || '',
    left: body.style.left || '',
    right: body.style.right || '',
    width: body.style.width || '',
    overflowY: body.style.overflowY || '',
  };
  body.style.position = 'fixed';
  body.style.top = `-${savedScrollY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
}

function releaseLock() {
  const body = document.body;
  if (savedStyles) {
    body.style.position = savedStyles.position;
    body.style.top = savedStyles.top;
    body.style.left = savedStyles.left;
    body.style.right = savedStyles.right;
    body.style.width = savedStyles.width;
    body.style.overflowY = savedStyles.overflowY;
    savedStyles = null;
  }
  window.scrollTo(0, savedScrollY);
}

/**
 * useBodyScrollLock(lock)
 * Prevents background scroll while overlays / asides are open (all platforms).
 * Ref-counted so stacked overlays keep the lock until the last one closes.
 * Restores scroll position on unlock.
 */
export default function useBodyScrollLock(lock: boolean) {
  useEffect(() => {
    if (!lock || typeof document === 'undefined') return;

    if (lockCount === 0) applyLock();
    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) releaseLock();
    };
  }, [lock]);
}
